<div class="container">
  <div class="row">
    <header><app-logo></app-logo></header>
    <main>
      <div class="banner">
        <h1 [innerHtml]="'ERROR.INELIGIBLE.HEAD' | translate"></h1>
      </div> 
      
      <div class="box full-height">
        <div class="box__left">
          <p [innerHtml]="'ERROR.INELIGIBLE.DESC' | translate"></p>
          
          <div tabindex="0" class="vlink" (click)="onBack()" (keydown)="onKeydown($event)" [innerHtml]="'ERROR.INELIGIBLE.CTA_BTN' | translate"></div>
          <br/>
          <br/>
          <a href="https://www.united.com/CMS/en-US/Marketing/CustComm/Promotions/Pages/Credit-Cardmember-Offers.aspx" target="_blank" [innerHtml]="'ERROR.VIEW_OTHER_BTN' | translate"></a>
          <br/>
        </div>
      </div>
    </main>

  </div>
</div>